// const header = $('.header')

// $(window).on('load scroll', () => {
//   const scrolled = $(window).scrollTop()

//   header[scrolled > 0 ? 'addClass' : 'removeClass'](
//     'header_is_sticky',
//   )
// })

$('.js-headerMenuButton').on('click', (e) => {
  const currentTarget = $(e.currentTarget)
  const id = currentTarget.data('id')
  const menu = $(`[data-menu-id="${id}"]`)

  if (currentTarget.hasClass('is_active')) {
    currentTarget.removeClass('is_active')
    $('[data-menu-id]').removeClass('menu-dropdown_is_opened')
    return
  }

  currentTarget
    .addClass('is_active')
    .siblings()
    .removeClass('is_active')

  $('[data-menu-id]').removeClass('menu-dropdown_is_opened')
  menu.addClass('menu-dropdown_is_opened')
})

$('.js-menuDropdownClose').on('click', () => {
  $('[data-menu-id]').removeClass('menu-dropdown_is_opened')
  $('.js-headerMenuButton').removeClass('is_active')
})
